var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8018 4.02253H4.10965C3.10637 4.02253 2.2915 4.8374 2.2915 5.84067V21.1819C2.2915 22.1851 3.10637 23 4.10965 23H14.8018C15.8051 23 16.62 22.1851 16.62 21.1819V5.84067C16.6153 4.8374 15.8004 4.02253 14.8018 4.02253ZM15.3435 21.1771C15.3435 21.4786 15.0986 21.7235 14.7971 21.7235H4.10494C3.80348 21.7235 3.55855 21.4786 3.55855 21.1771V5.84067C3.55855 5.53922 3.80348 5.29429 4.10494 5.29429H14.7971C15.0986 5.29429 15.3435 5.53922 15.3435 5.84067V21.1771Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8903 0H8.19815C7.19487 0 6.38 0.814868 6.38 1.81814C6.38 2.17141 6.66262 2.45402 7.01588 2.45402C7.36915 2.45402 7.65176 2.17141 7.65176 1.81814C7.65176 1.51669 7.8967 1.27176 8.19815 1.27176H18.8903C19.1918 1.27176 19.4367 1.51669 19.4367 1.81814V17.1593C19.4367 17.4608 19.1918 17.7057 18.8903 17.7057C18.5371 17.7057 18.2545 17.9883 18.2545 18.3416C18.2545 18.6949 18.5371 18.9775 18.8903 18.9775C19.8936 18.9775 20.7085 18.1626 20.7085 17.1593V1.81814C20.7085 0.814868 19.8936 0 18.8903 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fb30962f.svg";
export { ForwardRef as ReactComponent };